module.exports = __webpack_public_path__ + "img/icon-settings.cf10d81e.svg";